// Importing necessary libraries and components
import { Box, Link } from "@mui/material";
import React, { useState } from "react";
import "./InsurancePolicyDetail.scss";
import { useNavigate } from "react-router-dom";
import InitiateAClaim from "../../../../../Components/Broker/Claim/InitiateAClaimSp/InitiateAClaim";
import AddNewRequest from "../../../../../Components/Broker/Endorsment/AddNewRequest/AddNewRequest";
import AddMember from "../../../Broker/Employees/EmployeeDetails/AddMember/AddMember";
import AddNominee from "../../../Broker/Employees/EmployeeDetails/AddNominee/AddNominee";
import ViewDocuments from "../../../../../Components/Broker/Claim/ViewDocuments/ViewDocuments";
// Interface to define the types of the props
interface InsurancePolicyDetailsProps {
  productlogo?: string;
  insurerlogo?: string;
  heading1?: string;
  heading2?: string;
  heading3?: string;
  spanheading1?: string;
  spanheading2?: string;
  spanheading3?: string;
  classvalue?: string;
  boxcolor?: string;
  colorid?: string;
}
// Functional component for Insurance Policy Details
const InsurancePolicyDetails: React.FC<InsurancePolicyDetailsProps> = ({
  productlogo,
  insurerlogo,
  heading1,
  heading2,
  heading3,
  spanheading1,
  spanheading2,
  spanheading3,
  classvalue,
  boxcolor,
  colorid,
}) => {
  const navigate = useNavigate();
  const [addNewRequest, setAddNewRequest] = React.useState(false);
  const [addNewMember, setAddMember] = React.useState(false);
  const [addNominee, setAddNominee] = React.useState(false);
  const [InitiateClaim, setInitiateClaim] = React.useState(false);
  const [viewDocuments, setViewDocuments] = React.useState(false);
  const updateMasterState = (attrName: any, value: string) => {
    attrName(value);
  };
  return (
    <>
      <AddNewRequest
        attrName={setAddNewRequest}
        open_status={addNewRequest}
        value_update={updateMasterState}
      />
      <InitiateAClaim
        attrName={setInitiateClaim}
        open_status={InitiateClaim}
        value_update={updateMasterState}
        client_id_status={true}
      />
      <AddMember
        attrName={setAddMember}
        open_status={addNewMember}
        value_update={updateMasterState}
      />
      <AddNominee
        attrName={setAddNominee}
        open_status={addNominee}
        value_update={updateMasterState}
      />
      <ViewDocuments
        attrName={setViewDocuments}
        open_status={viewDocuments}
        value_update={updateMasterState}
      />
      <Box>
        <div className="insurance_box">
          <svg
            viewBox="0 0 500 150"
            preserveAspectRatio="none"
            className={`viewBox ${boxcolor}`}
            // className="viewBox health"
          >
            <defs>
              <linearGradient
                id={colorid}
                x1="50%"
                y1="-2.48949813e-15%"
                x2="50%"
                y2="100%"
              >
                <stop className="stop-color-red" offset="0%" />
                <stop className="stop-color-yellow" offset="100%" />
              </linearGradient>
            </defs>
            <path
              d="M0.00,49.98 C254.51,72.06 306.43,22.41 500.00,49.98 L500.00,150.00 L0.00,150.00 Z"
              fill={`url(#${colorid})`}
            ></path>
          </svg>
          <div className={`inner_box ${classvalue}`}>
            <img src={productlogo} alt="Product Logo" />
            <h5>
              {heading1} <span>{spanheading1}</span>
            </h5>
          </div>
          <div className="policy_box">
            <img src={insurerlogo} alt="Insurer Logo" />
            <h5>
              {heading2}
              <span>{spanheading2}</span>
            </h5>
          </div>
          <div className="coverage_ection">
            <p>
              {heading3} <span>{spanheading3}</span>
            </p>
          </div>
          <div className="module_overlay">
            <ul>
              <li>
                <Link
                  className="module_list1"
                  onClick={() => {
                    setAddNewRequest(true);
                  }}
                >
                  Endorsement
                </Link>
              </li>
              <li>
                <Link
                  className="module_list2"
                  onClick={() => {
                    setInitiateClaim(true);
                  }}
                >
                  Register Claim
                </Link>
              </li>
              <li>
                <Link
                  className="module_list3"
                  onClick={() => {
                    setAddMember(true);
                  }}
                >
                  Add Member
                </Link>
              </li>
              <li>
                <Link
                  className="module_list4"
                  onClick={() => {
                    navigate("/GroupHealthPolicy");
                  }}
                >
                  Policy Details
                </Link>
              </li>
              <li>
                <Link
                  className="module_list3"
                  onClick={() => {
                    setAddNominee(true);
                  }}
                >
                  Add Nominee
                </Link>
              </li>
              <li>
                <Link
                  className="module_list5"
                  onClick={() => {
                    setViewDocuments(true);
                  }}
                >
                  Download E-Card
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </Box>
    </>
  );
};
// Exporting the component
export default InsurancePolicyDetails;
